import {css, Theme} from "@emotion/react";

import {m} from "@pg-design/helpers-css";
import {borderRadius, p} from "@pg-design/helpers-css-strings";
import {Modal} from "@pg-design/modal-module";

import {useUserUpdatePhoneNumberModalContext} from "../context/UserUpdatePhoneNumberModalContext";
import {IUserUpdatePhoneNumberFormProps, UserUpdatePhoneNumberForm} from "./UserUpdatePhoneNumberForm";

type IProps = IUserUpdatePhoneNumberFormProps;

export const UserUpdatePhoneNumberModal = (props: IProps) => {
    const {isOpen} = props;
    const context = useUserUpdatePhoneNumberModalContext();

    return (
        <Modal isOpen={isOpen} onModalClose={context.onClose} css={modalStyle}>
            <Modal.CloseButton
                placement="right"
                variant="rounded"
                css={css`
                    ${m(2)}
                `}
            />
            <Modal.Content>
                <UserUpdatePhoneNumberForm {...props} />
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(2)};
        ${borderRadius(2)};
        width: 544px;
    }
`;
import {css, Theme} from "@emotion/react";

import {m} from "@pg-design/helpers-css";
import {borderRadius, p} from "@pg-design/helpers-css-strings";
import {Modal} from "@pg-design/modal-module";

import {useUserUpdatePhoneNumberModalContext} from "../context/UserUpdatePhoneNumberModalContext";
import {IUserUpdatePhoneNumberFormProps, UserUpdatePhoneNumberForm} from "./UserUpdatePhoneNumberForm";

type IProps = IUserUpdatePhoneNumberFormProps;

export const UserUpdatePhoneNumberModal = (props: IProps) => {
    const {isOpen} = props;
    const context = useUserUpdatePhoneNumberModalContext();

    return (
        <Modal isOpen={isOpen} onModalClose={context.onClose} css={modalStyle}>
            <Modal.CloseButton
                placement="right"
                variant="rounded"
                css={css`
                    ${m(2)}
                `}
            />
            <Modal.Content>
                <UserUpdatePhoneNumberForm {...props} />
            </Modal.Content>
        </Modal>
    );
};

const modalStyle = (theme: Theme) => css`
    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(2)};
        ${borderRadius(2)};
        width: 544px;
    }
`;
